module.exports = __webpack_public_path__ + "img/function.2b2d0cf3.png";